import FloatFormat from "../FloatFormat";

interface IText {
  value: string | number;
}

const IntegerWithZero = ({ value }: IText) => {
  return <>{value === null ? '—' : <FloatFormat value={value} />}</>;
};

export default IntegerWithZero;
